// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"lZ-z"};